/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React, { useEffect, useState, useCallback, useRef } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBackspace, faBarcode, faBox, faCalendar, faCheckCircle, faCheckDouble, faDollarSign, faEdit, faFileCsv, faHome, faPeopleArrows, faPlug, faRocket, faSave, faTasks, faUpload, faUserShield } from "@fortawesome/free-solid-svg-icons"
import { Badge, Breadcrumb, Button, ButtonGroup, Card, Col, Dropdown, InputGroup, ProgressBar, Row, Table } from '@themesberg/react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import { Form } from '@themesberg/react-bootstrap';
import _ from "lodash"
import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from "../../core/API"
import { ApiSrc } from "../../resources/ApiSrc"
const moment = require('moment');
import Swal from 'sweetalert2/dist/sweetalert2.js'
var Barcode = require('react-barcode');
import Datetime from "react-datetime";

import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Typography from '@material-ui/core/Typography';
import { WaybillStatusType } from "../waybills/WaybillPage"

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ['Pending', 'Warehouse', 'Ready For Transit', 'Transit', 'Arrived', 'Received'];
}
export default (props) => {
    const inputRef = useRef(null);

    const [waybill, setWaybill] = useState()
    const [receivedAt, setReceivedAt] = useState()
    const [arrivedAt, setArrivedAt] = useState()
    const [reference, setReference] = useState()
    const [width, setWidth] = useState()
    const [height, setHeight] = useState()
    const [length, setLength] = useState()
    const [weight, setWeight] = useState()
    const [volume, setVolume] = useState()
    const [freightFee, setFreightFee] = useState()
    const [status, setStatus] = useState('Arrived')
    const [progressValue, setProgressValue] = useState();

    const [paid, setPaid] = useState()
    const [paidAmount, setPaidAmount] = useState()
    const [paidAt, setPaidAt] = useState()

    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState(new Set());
    const steps = getSteps();

    const [selectedDate, setSelectedDate] = useState(moment())

    const dispatch = useDispatch();

    const keyPressFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            setWaybill(undefined)
        }
        if (event.keyCode === 13) {
            //scan()
        }
    }, [waybill, receivedAt, reference, width, height, length, weight, volume, freightFee, status]);

    useEffect(() => {
        document.addEventListener("keydown", keyPressFunction, false);

        return () => {
            document.removeEventListener("keydown", keyPressFunction, false);
        };
    }, [keyPressFunction]);

    useEffect(() => {
        if (reference && reference.length > 8) scan()
    }, [reference])

    const scan = () => {
        if (waybill) setWaybill(undefined)
        PostRequest(ApiSrc.DETAIL_WAYBILL, { input: { reference } }).then(result => {
            GetResultObject(result, 'data', 200, (data, page) => {
                console.log('>> waybill', data)
                setWaybill(data)
            })
        })
    }

    useEffect(() => {
        if (status == WaybillStatusType.RECEIVED) {
            setSelectedDate(receivedAt ? moment(receivedAt) : moment())
            console.log(">receivedAt", receivedAt)
        } else {
            setSelectedDate(arrivedAt ? moment(arrivedAt) : moment())
            console.log(">arrivedAt", arrivedAt)
        }
    }, [status, receivedAt, arrivedAt])

    useEffect(() => {
        if (waybill) {
            const index = steps.findIndex((value) => { return (value == _.get(waybill, 'status')) })
            console.log("> index", index)
            setActiveStep(index <= 0 ? 0 : index)
            setWidth(_.get(waybill, 'width'))
            setHeight(_.get(waybill, 'height'))
            setLength(_.get(waybill, 'length'))
            setWeight(_.get(waybill, 'weight'))
            setVolume(_.get(waybill, 'volume'))
            setFreightFee(_.get(waybill, 'freightFee'))
            setReceivedAt(_.get(waybill, 'receivedAt'))
            setArrivedAt(_.get(waybill, 'arrivedAt'))

            setPaid(_.get(waybill, 'paid'))
            setPaidAmount(_.get(waybill, 'paidAmount'))
            setPaidAt(_.get(waybill, 'paidAt'))

            if (_.get(waybill, 'status') == WaybillStatusType.RECEIVED) {
                setStatus(WaybillStatusType.RECEIVED)
            }
        } else {
            setPaid(undefined)
            setPaidAmount('')
            setPaidAt(undefined)
            setWidth('')
            setHeight('')
            setLength('')
            setWeight('')
            setVolume('')
            setFreightFee('')
            setReference('')
            setActiveStep(-1)
            setReceivedAt(undefined)
            setArrivedAt(undefined)
            setSelectedDate(moment())
            inputRef.current.focus();
        }
    }, [waybill])


    const onUpdate = () => {
        setProgressValue(1)
        if (waybill == undefined) return;
        const body = {
            id: _.get(waybill, 'id'),
            status,
            height,
            width,
            weight,
            length,
            volume,
            freightFee,
            paidAmount,
            paidAt,
        }

        if (status == WaybillStatusType.RECEIVED) {
            body.receivedAt = selectedDate
        }

        if (status == WaybillStatusType.ARRIVED) {
            body.arrivedAt = selectedDate
        }

        if (paidAmount && paidAt) {
            body.paid = true
        }

        if(body.status == WaybillStatusType.ARRIVED) {
            body.status = WaybillStatusType.TRANSIT
        }

        console.log('>> body', body)

        PostRequest(ApiSrc.UPDATE_WAYBILL, { input: { ...body }, token: null }).then(result =>
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(WaybillAction.updateWaybillSuccess(data));
                setWaybill(undefined)
                setProgressValue(undefined)
            })
        )
    }

    return (<>
        {
            progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
        }


        <Card>
            <Card.Header>
                <div className={classes.root} style={{ overflowX: 'auto' }}>
                    <Stepper alternativeLabel nonLinear activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const buttonProps = {};
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepButton
                                        //onClick={handleStep(index)}
                                        //completed={isStepComplete(index)}
                                        {...buttonProps}
                                    >
                                        {label}
                                    </StepButton>
                                </Step>
                            );
                        })}
                    </Stepper>
                </div>
            </Card.Header>
            <Card.Body>

                <Row>

                    <Col xs={12} sm={6} xl={4} className="mb-4">

                        <Form.Group className="mb-4">
                            <Form.Label>Reference Code</Form.Label>
                            <InputGroup>
                                <InputGroup.Text className="border-danger">
                                    <FontAwesomeIcon icon={faBarcode} />
                                </InputGroup.Text>
                                <Form.Control
                                    ref={inputRef}
                                    autoFocus={true}
                                    className="border-danger"
                                    required type="text"
                                    value={reference}
                                    onChange={(e) => { setReference(e.target.value == '' ? undefined : e.target.value) }} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <InputGroup>
                                <Form.Select onChange={(e) => {
                                    setStatus(e.target.value == "--Select--" ? undefined : e.target.value)
                                }}>
                                    <option value={WaybillStatusType.TRANSIT} selected={status === WaybillStatusType.ARRIVED}>Transit</option>                                
                                    <option value={WaybillStatusType.ARRIVED} selected={status === WaybillStatusType.ARRIVED}>Arrived</option>
                                    {/* <option value={WaybillStatusType.RECEIVED} selected={status === WaybillStatusType.RECEIVED}>Received</option> */}
                                </Form.Select>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>{status == WaybillStatusType.RECEIVED ? 'Received Date' : 'Arrived Date'}</Form.Label>
                            <Datetime
                                timeFormat={false}
                                onChange={setSelectedDate}
                                renderInput={(props, openCalendar) => (
                                    <InputGroup>
                                        <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                                        <Form.Control
                                            required
                                            type="text"
                                            value={moment(selectedDate).format("MM-DD-YYYY")}
                                            placeholder="MM-DD-YYYY"
                                            onFocus={openCalendar} />
                                    </InputGroup>
                                )} />
                        </Form.Group>

                        {
                            waybill && (
                                <>
                                    <Form.Group className="mb-4">
                                        <InputGroup>
                                            <Barcode value={_.get(waybill, 'warehouse.accountNo')} />
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group className="mb-4">
                                        <InputGroup>
                                            <Barcode value={_.get(waybill, 'reference')} />
                                        </InputGroup>
                                    </Form.Group>
                                </>
                            )
                        }

                        {
                            _.get(waybill, 'photo') && (
                                <Form.Group className="mb-4">
                                    <img src={_.get(waybill, 'photo')} />
                                </Form.Group>
                            )
                        }

                    </Col>

                    <Col xs={1} sm={1} xl={1} className="mb-4"></Col>
                    <Col xs={12} sm={6} xl={6} className="mb-4">
                        <Form.Group className="mb-4">
                            <Row>
                                <Col xs={12} sm={6} xl={4}>
                                    <Form.Label>Width(cm)</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faBox} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            required type="number"
                                            onChange={(e) => { setWidth(e.target.value) }}
                                            value={width} />
                                    </InputGroup>
                                </Col>
                                <Col xs={12} sm={6} xl={4}>
                                    <Form.Label>Height(cm)</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faBox} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            required type="number"
                                            onChange={(e) => { setHeight(e.target.value) }}
                                            value={height} />
                                    </InputGroup>
                                </Col>
                                <Col xs={12} sm={6} xl={4}>
                                    <Form.Label>Length(cm)</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faBox} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            required type="number"
                                            onChange={(e) => { setLength(e.target.value) }}
                                            value={length} />
                                    </InputGroup>
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Weight(kg)</Form.Label>

                            <InputGroup>
                                <InputGroup.Text>
                                    <FontAwesomeIcon icon={faBox} />
                                </InputGroup.Text>
                                <Form.Control
                                    required type="number"
                                    onChange={(e) => { setWeight(e.target.value) }}
                                    value={weight} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Volume(cmb)</Form.Label>

                            <InputGroup>
                                <InputGroup.Text>
                                    <FontAwesomeIcon icon={faBox} />
                                </InputGroup.Text>
                                <Form.Control
                                    required type="number"
                                    onChange={(e) => { setVolume(e.target.value) }}
                                    value={volume} />
                            </InputGroup>
                        </Form.Group>

                        <Row>
                            <Col xs={12} sm={6} xl={4}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Freight Fee($)</Form.Label>

                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faDollarSign} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            onChange={(e) => { setFreightFee(e.target.value) }}
                                            required type="number"
                                            value={freightFee} />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6} xl={4}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Paid Amount($)</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faCheckCircle} color={paid ? 'green' : ''} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            readOnly={true}
                                            onChange={(e) => { setPaidAmount(e.target.value) }}
                                            required type="number"
                                            value={paidAmount} />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={6} xl={4}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Settled Date</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faCalendar} color={paid ? 'green' : ''} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            readOnly={true}                                            
                                            required type="text"
                                            value={paidAt ? moment(paidAt).format("MM-DD-YYYY") : ''} />
                                    </InputGroup>
                                </Form.Group>
                                {/* <Form.Group className="mb-4">
                                    <Form.Label>Settled At</Form.Label>
                                    <Datetime
                                        readOnly={true}
                                        timeFormat={false}
                                        onChange={setPaidAt}
                                        renderInput={(props, openCalendar) => (
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                                                <Form.Control
                                                    readOnly={true}
                                                    type="text"
                                                    value={paidAt ? moment(paidAt).format("MM-DD-YYYY") : ''}
                                                    placeholder="MM-DD-YYYY"
                                                    onFocus={openCalendar} />
                                            </InputGroup>
                                        )} />
                                </Form.Group> */}
                            </Col>
                        </Row>
                        <br /><br /><br />

                        {/* <small>Press save or `Enter Key` to save the update data</small> &nbsp; */}
                        <Form.Group className="mb-4 float-end">
                            <Button className={"bg-danger"} onClick={() => { setWaybill(undefined) }}><FontAwesomeIcon icon={faBackspace} /> Clear</Button>&nbsp;&nbsp;&nbsp;
                            <Button onClick={onUpdate}><FontAwesomeIcon icon={faSave} /> Save</Button>
                        </Form.Group>

                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </>)
}